let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4oBTk")).then(() => parcelRequire('3EYJt'));